import { Device } from './device';
import { DeviceStatus, errored } from './device-status';
import { DevicesTree } from './device-tree';
import { User } from './user';

export class Site {
	Id?: number;
	Name = '';
	Description = '';
	Address = '';
	Timezone = '';
	Latitude = 45.619317;
	Longitude = 12.262963;
	UserId?: number;
	CurrentlyOwned: boolean;
	TechnicianId?: number;
	Devices?: Device[] = [];
	DevicesTree?: DevicesTree;
	Disabled: boolean;
	User: User;
	DeviceOnline?: number;
	DeviceOffline?: number;
	isOnlySiteVct: boolean;
}

export class SiteExtTechAcl {
	Id?: number;
	Name = '';
	Description = '';
	Address = '';
	Timezone = '';
	Latitude = 0.0;
	Longitude = 0.0;
	UserId?: number;
	CurrentlyOwned?: boolean;
	TechnicianId?: number;
	LocaluserId?: number;
	User?: User;
	TechnicianIdReqOpen?: number;
	GeoLocalized?: boolean;
	CurrentlyOpenedTicket: boolean;
	Devices: Device[] = [];
}

export class LocalSite {
	Id?: number;
	Name = '';
	Description = '';
	Address = '';
	Timezone = '';
	Latitude = 0.0;
	Longitude = 0.0;
	OwnerId?: number;
	LocaluserId?: number;
	UpdatedAt?: Date;
	Version?: number;
	GeoLocalized?: boolean;
}

export class SiteGroup {
	label: string;
	sites: Site[];

	constructor(label: string, sites: Site[]) {
		this.label = label;
		this.sites = sites;
	}
}

export class SiteStatus {
	Site: Site;
	SiteId: number;
	Empty: boolean;
	DeviceStatus: DeviceStatus[];
	GeoLocalized: boolean;
	Longitude: number;
	Latitude: number;
	Errored = false; // any error on a device
	Offline = false; // any offline device
	Owner: User;
	CurrentlyOpenedTicket: boolean;

	constructor(site: Site) {
		this.Site = site;
		this.SiteId = site.Id;
		this.GeoLocalized = !!(site.Latitude && site.Longitude);
		this.Longitude = site.Longitude;
		this.Latitude = site.Latitude;
		this.Empty = site.Devices.length === 0;
	}
}

export const setSiteStatus = (siteStatus: SiteStatus, deviceStatus: DeviceStatus[]) => {
	let errors: boolean[] = [];
	for (const deviceStat of deviceStatus) {
		errors = errors.concat(deviceStat.States.map(state => errored(state)));
	}
	return { ...siteStatus, Errored: errors.some(err => err === true), Offline: deviceStatus.some(ds => ds.Online === false) };
};


export const setSiteOwner = (siteStatus: SiteStatus, owner: User): SiteStatus => ({ ...siteStatus, Owner: owner });
